var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeDetail"},[_c('img',{attrs:{"src":require("../assets/imgs/homeBg.jpg"),"alt":""}}),_c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{attrs:{"src":require("../assets/imgs/detail2.png"),"alt":"back"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }